import {
	Component,
	NgZone
} from "@angular/core";
import {
	App,
	NavController,
	NavParams,
	Events,
	ModalController
} from "ionic-angular";
import * as moment from "moment";

import {
	TabOrder
} from "../../orders/tabs/tab-order";

import {
	AddOrderServiceProvider
} from "./../add-order.service";

import {
	APIServiceProvider
} from "./../../../common/services/api.service";
import {
	HelperServiceProvider
} from "./../../../common/services/helper.service";
import {
	FarmersPage
} from "../../../pages/farmers/farmers";

import {
	ProductModalPage
} from "./../../../modals/product/product.modal";
import {
	DepoModalPage
} from "./../../../modals/depo/depo.modal";
import {
	environment
} from "./../../../environments/environment";
import {
	NotifyService
} from "../../../services/notify.service";
import {
	HomePage
} from "../../home/home";

@Component({
	selector: "page-placeorder",
	templateUrl: "placeorder.html"
})
export class PlaceOrderPage {
	constructor(
		public navCtrl: NavController,
		public helperService: HelperServiceProvider,
		public navParams: NavParams,
		public zone: NgZone,
		public events: Events,
		public modalController: ModalController,
		public addOrderService: AddOrderServiceProvider,
		public apiService: APIServiceProvider,
		public app: App,
		private notifyService: NotifyService,
		public nav: NavController,

	) {}

	public address_list = [];
	all_added_products: any = [];

	saveCustomerBtn = false;

	orderData: any = {
		grand_total: 0,
		sub_total: 0,
		gram_cash: 0,
		additional_discount: 0,
		total_additional_discount: 0,
		coupon_id: "",
		coupon_discount: 0,
		credit_order: false
	};

	isPlaceOrderIsRunning = false;
	accessType = false;
	ionViewDidLoad() {
		console.log("ionViewDidLoad PlaceOrderPage");

		this.events.subscribe("addorderproduct-selected", product => {
			this.selectedProduct(product);
		});

		this.events.subscribe("depo-selected", depo => {
			this.selectedDepo(depo);
		});
		if (localStorage.getItem('is_retailer') == 'true') {
			this.addOrderService.postData.place_order = "no"
			this.accessType = true
		} else {
			this.accessType = false
			this.addOrderService.postData.place_order = "yes"
		}
	}

	validateCustomerAddress() {
		return new Promise((resolve, reject) => {
			const url = "customer/" + this.addOrderService.postData.customer_id;
			this.apiService.get(url).subscribe(result => {
				const customerAddress = result["data"]["address"];
				if (!customerAddress) {
					return resolve(false);
				}
				if (
					customerAddress["state"] == null ||
					customerAddress["district"] == null ||
					customerAddress["village"] == null ||
					customerAddress["tehsil"] == null ||
					customerAddress["master_address_id"] == null ||
					customerAddress["master_address_id"] == "null" ||
					customerAddress["master_address_id"] == ""
				) {
					return resolve(false);
				}
				resolve(true);
			});
		});
	}

	handelPlaceOrderChange(ev) {
		let self = this;
		setTimeout(function() {
			if (self.addOrderService.postData.place_order == "yes") {
				self.validateAddressData();
			}
		}, 1000);
	}

	async validateAddressData() {
		// chECK FOR ADDRESS FROM db
		const addressValidation = await this.validateCustomerAddress();
		if (!addressValidation) {
			this.helperService.presentToast(
				"State , District , Tehsil or Village are required while placing order, Please click on Save & Continue"
			);

			this.navCtrl.parent.select(1);
			this.addOrderService.postData.place_order = "no";

			return;
		}
	}

	async continueCustomerOrder() {
		if (localStorage.getItem('is_retailer') == 'true') {

			this.apiService
				.post(
					"lead/add-retailer-lead", {
						mobile_no: this.addOrderService.postData.mobile_no
					}
				).subscribe(v => {
					this.helperService.presentToast(
						"Successfully Lead Send"
					);
					this.nav.push(HomePage);


				})
			return false
		}

		this.addOrderService.postData.other_discount = this.addOrderService.postData.additional_discount;
		this.addOrderService.postData.credit_order = this.addOrderService.orderData.credit_order;

		if (!this.addOrderService.postData.mobile_no ||
			this.addOrderService.postData.mobile_no == "" ||
			this.addOrderService.postData.mobile_no == 'null' ||
			this.addOrderService.postData.mobile_no.toString().length != 10) {

			this.helperService.presentToast(
				"Please enter mobile no to place order"
			);

			return false;
		}


		if (this.addOrderService.postData.place_order == "yes") {
			if (this.addOrderService.pre_projects.length === 0) {
				this.helperService.presentToast(
					"You have not selected place order Or not added products"
				);

				return false;
			}
		} else {
			if (this.isPlaceOrderIsRunning) {
				return false;
			}

			this.saveCustomerBtn = true;

			this.apiService
				.post("orders/update-place", this.addOrderService.postData)
				.subscribe(
					data => {
						this.helperService.presentToast(
							"Farmer details has been saved"
						);
						this.addOrderService.reInitializeData();
						this.app.getRootNav().setRoot(FarmersPage);

						this.saveCustomerBtn = false;
					},
					error => {
						this.saveCustomerBtn = false;
					}
				);

			return false;
		}

		// chECK FOR ADDRESS FROM db
		const addressValidation = await this.validateCustomerAddress();
		if (!addressValidation) {
			this.helperService.presentToast(
				"State , District , Tehsil or Village are required while placing order, Please click on Save & Continue"
			);

			this.navCtrl.parent.select(1);

			return;
		}

		if (
			this.addOrderService.postData.state == null ||
			this.addOrderService.postData.state == "" ||
			this.addOrderService.postData.district == null ||
			this.addOrderService.postData.district == "" ||
			this.addOrderService.postData.tehsil == null ||
			this.addOrderService.postData.tehsil == "" ||
			this.addOrderService.postData.village == null ||
			this.addOrderService.postData.village == ""
		) {
			this.helperService.presentToast(
				"State , District , Tehsil or Village are required while placing order, Please click on Save & Continue"
			);

			this.navCtrl.parent.select(1);

			return false;
		}

		this.addOrderService.postData.product_data.products = [];
		let noOrderData = false;

		this.addOrderService.pre_projects.forEach(project => {
			if (!project.product && !noOrderData) {
				noOrderData = true;
			}
		});

		if (noOrderData) {
			this.helperService.presentToast("Select product");

			return false;
		}

		let hasItemIssue = false;
		let hasIssue = false;

		this.all_added_products = [];

		this.addOrderService.pre_projects.forEach(project => {
			if (project.product) {
				if (isNaN(project.quantity) || project.quantity < 0) {
					this.helperService.presentToast(
						"Invalid additional quantity"
					);

					hasIssue = true;
				}

				if (project.quantity == "" || project.quantity == "0") {
					this.helperService.presentToast(
						"Invalid product quantity"
					);

					hasIssue = true;
				}

				if (isNaN(project.discount) || project.discount < 0) {
					this.helperService.presentToast(
						"Invalid additional quantity"
					);

					hasIssue = true;
				}

				if (!isNaN(project.discount) && project.discount > 0) {
					if (project.discount > project.total) {
						this.helperService.presentToast("Invalid coupon value");

						hasItemIssue = true;
					}
				}

				this.all_added_products.push(
					parseInt(project.product.product_id)
				);
			}

			this.addOrderService.postData.product_data.products.push({
				product_id: project.product.product_id,
				quantity: project.quantity,
				discount: project.discount
			});
		});

		if (hasIssue) {
			return false;
		}

		if (hasItemIssue) {
			return false;
		}

		if (
			parseFloat(this.addOrderService.orderData.additional_discount) >
			parseInt(this.addOrderService.orderData.sub_total)
		) {
			this.helperService.presentToast(
				"Additional discount should not be greater then total amount"
			);

			return false;
		}

		var checkDuplicates = this.hasDuplicates(this.all_added_products);

		if (checkDuplicates) {
			this.helperService.presentToast(
				"You have added duplicate products, please remove duplicate products"
			);

			return false;
		}

		this.addOrderService.postData.product_data.additional_discount = this.addOrderService.orderData.total_additional_discount;
		this.addOrderService.postData.product_data.customer_id = this.addOrderService.postData.customer_id;
		this.addOrderService.postData.product_data.comments = this.addOrderService.postData.comments;
		this.addOrderService.postData.product_data.other_discount = this.addOrderService.postData.product_data.additional_discount;
		this.addOrderService.postData.product_data.opportunity_id = this.addOrderService.postData.opportunity_id;

		this.addOrderService.postData.product_data.credit_order = this.addOrderService.orderData.credit_order;

		if (this.isPlaceOrderIsRunning) {
			return false;
		}

		this.isPlaceOrderIsRunning = true;
		this.saveCustomerBtn = true;

		if (
			typeof this.addOrderService.postData.order_id === undefined ||
			!this.addOrderService.postData.order_id
		) {
			this.apiService
				.post(
					"orders/place-order",
					this.addOrderService.postData.product_data
				)
				.subscribe(
					data => {
						this.saveCustomerBtn = false;
						this.isPlaceOrderIsRunning = false;

						if (!data['status']) {
							this.addOrderService.postData.order_id = data["data"];
							this.addOrderService.postData.order_details =
								data["data"];
							this.notifyService.OrderPlaced(true);
							this.saveOpportunityDataOpt();
						} else {
							this.helperService.presentToast(data['message']);
						}
					},
					error => {
						this.saveCustomerBtn = false;
						this.isPlaceOrderIsRunning = false;
					}
				);
		} else {
			this.apiService
				.post(
					"orders/update-order",
					this.addOrderService.postData.product_data
				)
				.subscribe(
					data => {
						this.saveCustomerBtn = false;
						this.isPlaceOrderIsRunning = false;

						this.notifyService.OrderPlaced(true);
						this.savePlaceOrderData();
						this.continueOtherOpportunity();
					},
					error => {
						this.saveCustomerBtn = false;

						var message = error["error"]["msg"];

						for (var i = 0; i <= 5; i++) {
							message = message.replace("<br>", " ");
						}

						this.helperService.presentToast(message);
					}
				);
		}
	}

	hasDuplicates(array: any) {
		var valuesSoFar = Object.create(null);
		for (var i = 0; i < array.length; ++i) {
			var value = array[i];
			if (value in valuesSoFar) {
				return true;
			}
			valuesSoFar[value] = true;
		}
		return false;
	}

	updatePlceOrderStatus() {
		this.apiService
			.post("orders/update-place", this.addOrderService.postData)
			.subscribe(data => {});
	}

	updateCommentsOpor() {
		this.apiService
			.post("opportunities/update", {
				comments: this.addOrderService.postData.comments,
				opportunity_id: this.addOrderService.postData.opportunity_id
			})
			.subscribe(data => {});
	}

	savePlaceOrderData() {
		this.apiService
			.post("opportunities/update", this.addOrderService.postData)
			.subscribe(data => {});
	}

	continueOtherOpportunity() {
		if (this.addOrderService.postData.place_order == "yes") {
			if (this.addOrderService.pre_projects.length === 0) {
				this.helperService.presentToast(
					"You have not selected place order Or not added products"
				);

				this.navCtrl.parent.select(4);
				return;
			}
		}

		this.apiService
			.post("customer/save-customer", this.addOrderService.postData)
			.subscribe(response => {
				this.addOrderService.postData.customer_id = response["data"];

				this.helperService.presentToast("Order has been placed");
				this.addOrderService.reInitializeData();

				this.app.getRootNav().setRoot(TabOrder);
			});
	}

	saveOpportunityDataOpt() {
		this.apiService
			.post("opportunities/add", this.addOrderService.postData)
			.subscribe(response => {
				this.addOrderService.postData.opportunity_id = response["data"];

				this.savePlaceOrderData();
				//this.updateCommentsOpor();
				this.continueOtherOpportunity();
			});
	}

	selectedProduct(product) {
		var index = product.requestIndex;

		this.addOrderService.pre_projects[index].product = product;

		this.addOrderService.pre_projects[index].product_field_app_name =
			product.product_field_app_name;

		this.addOrderService.pre_projects[index].product_sku =
			product.product_sku;

		let total =
			(parseFloat(product.product_selling_price) -
				this.addOrderService.pre_projects[index].discount) *
			this.addOrderService.pre_projects[index].quantity;

		if (total <= 0) {
			total = 0;
		}

		this.zone.run(() => {
			this.addOrderService.pre_projects[index].total = total;
			this.calculateSubTotal();
		});

		var defaultDepoName: any = localStorage.getItem("user_depo_name");
		var defaultDepoID: any = localStorage.getItem("user_depo_id");

		if (
			defaultDepoID == null ||
			defaultDepoID == "" ||
			defaultDepoID == "null"
		) {
			defaultDepoID = environment.CDC_DEPO_ID;
		}

		if (
			defaultDepoName == null ||
			defaultDepoName == "" ||
			defaultDepoName == "null"
		) {
			defaultDepoName = environment.CDC_DEPO_NAME;
		}

		this.checkAval(
			index,
			product.product_id,
			defaultDepoName,
			defaultDepoID
		);
	}

	calculateSubTotal() {
		this.addOrderService.orderData.sub_total = 0;

		this.addOrderService.pre_projects.forEach(project => {
			this.addOrderService.orderData.sub_total =
				parseFloat(this.addOrderService.orderData.sub_total) +
				parseFloat(project.total);
		});

		this.additionalDiscount();
	}

	additionalDiscount() {

		if (
			parseFloat(this.addOrderService.orderData.additional_discount) >
			parseInt(this.addOrderService.orderData.sub_total)
		) {
			this.helperService.presentToast(
				"Additional discount should not be greater then total amount"
			);

			this.addOrderService.orderData.additional_discount = 0;
			this.addOrderService.orderData.total_additional_discount = 0;

			return false;
		}

		this.addOrderService.orderData.total_additional_discount =
			parseFloat(this.addOrderService.orderData.additional_discount) +
			parseFloat(this.addOrderService.orderData.coupon_discount);

		if (this.addOrderService.orderData.total_additional_discount <= 0) {
			this.addOrderService.orderData.total_additional_discount = 0;
		}

		this.addOrderService.orderData.grand_total =
			parseFloat(this.addOrderService.orderData.sub_total) -
			parseFloat(
				this.addOrderService.orderData.total_additional_discount
			);

		if (this.addOrderService.orderData.grand_total <= 0) {
			this.addOrderService.orderData.grand_total = 0;
		}
	}

	changeDiscount(product, index) {
		if (
			parseInt(product.discount) >
			parseInt(product.product.product_selling_price)
		) {
			this.zone.run(() => {
				this.addOrderService.pre_projects[index].discount = parseInt(
					product.product.product_selling_price
				);
			});

			return;
		}

		let total =
			(parseFloat(product.product.product_selling_price) -
				product.discount) *
			product.quantity;

		if (total <= 0) {
			total = 0;
		}

		this.zone.run(() => {
			this.addOrderService.pre_projects[index].total = total;
			this.calculateSubTotal();
		});
	}

	changeQTY(product, index) {
		let total =
			(parseFloat(product.product.product_selling_price) -
				product.discount) *
			product.quantity;

		if (total <= 0) {
			total = 0;
		}

		this.zone.run(() => {
			this.addOrderService.pre_projects[index].total = total;
			this.calculateSubTotal();
		});
	}

	applyDiscount() {
		this.apiService
			.post("coupons/validate-coupon", {
				coupon_name: this.addOrderService.orderData.coupon_id,
				order_amount: this.addOrderService.orderData.sub_total
			})
			.subscribe(data => {
				if (data["status"] == "error") {
					this.helperService.presentToast(data["message"]);
				}

				if (data["status"] == "success") {
					this.helperService.presentToast(data["message"]);
					this.addOrderService.orderData.coupon_discount = parseFloat(
						data["discount"]
					);
					this.additionalDiscount();
				}
			});
	}

	selectProduct(index) {
		let modalObject: any = {};

		modalObject = this.modalController.create(ProductModalPage, {
			index: index,
			customer_id: this.addOrderService.postData.customer_id
		}, {
			cssClass: "lg-modal"

		});

		modalObject.present();
	}

	removeDiscount() {
		this.addOrderService.orderData.coupon_discount = 0;
		this.addOrderService.orderData.coupon_id = "";
		this.additionalDiscount();
	}

	discardCart() {
		if (this.addOrderService.pre_projects.length === 0) {
			this.helperService.presentToast(
				"You dont have any cart information"
			);

			return;
		}

		let cartInfo: any = {
			customer_id: this.addOrderService.postData.customer_id
		};

		this.apiService
			.post("orders/discard-to-cart", cartInfo)
			.subscribe(data => {
				this.addOrderService.postData.place_order = "no";
				this.addOrderService.pre_projects = [];
				this.addOrderService.postData.cart_action_date = null;
				this.addOrderService.hascartinfo = false;

				this.orderData = {
					grand_total: 0,
					sub_total: 0,
					additional_discount: 0,
					total_additional_discount: 0,
					coupon_id: "",
					coupon_discount: 0
				};

				this.addOrderService.orderData = {
					grand_total: 0,
					sub_total: 0,
					additional_discount: 0,
					total_additional_discount: 0,
					coupon_id: "",
					coupon_discount: 0
				};
			});
	}

	saveToCart() {
		if (this.addOrderService.pre_projects.length === 0) {
			this.helperService.presentToast(
				"You have not selected place order Or not added products"
			);

			return;
		}

		this.addOrderService.postData.product_data.products = [];
		let noOrderData = false;

		this.addOrderService.pre_projects.forEach(project => {
			if (!project.product && !noOrderData) {
				noOrderData = true;
			}
		});

		if (noOrderData) {
			this.helperService.presentToast("Select product to continue");

			return;
		}

		this.all_added_products = [];

		this.addOrderService.pre_projects.forEach(project => {
			this.addOrderService.postData.product_data.products.push({
				product_id: project.product.product_id,
				quantity: project.quantity,
				discount: project.discount
			});
		});

		var checkDuplicates = this.hasDuplicates(this.all_added_products);

		if (checkDuplicates) {
			this.helperService.presentToast(
				"You have added duplicate products, please remove duplicate products"
			);

			return false;
		}

		if (
			typeof this.addOrderService.postData.cart_action_date ===
			"undefined" ||
			this.addOrderService.postData.cart_action_date === null ||
			this.addOrderService.postData.cart_action_date === ""
		) {
			this.helperService.presentToast(
				"Please select the future date when you want this reminder"
			);

			return false;
		}

		this.addOrderService.postData.product_data.hascartinfo = this.addOrderService.hascartinfo;
		this.addOrderService.postData.product_data.customer_id = this.addOrderService.postData.customer_id;
		this.addOrderService.postData.product_data.cart_action_date = moment(
			this.addOrderService.postData.cart_action_date
		).format("YYYY-MM-DD");

		this.addOrderService.postData.product_data.other_discount = this.addOrderService.postData.additional_discount;

		if (this.isPlaceOrderIsRunning) {
			return;
		}

		this.isPlaceOrderIsRunning = true;

		this.apiService
			.post(
				"orders/add-to-cart",
				this.addOrderService.postData.product_data
			)
			.subscribe(data => {
				this.addOrderService.postData.cart_reference_id = data["data"];
				this.addOrderService.postData.place_order = "no";
				this.saveCustomerBtn = false;

				this.helperService.presentToast("Cart has been saved");
				this.addOrderService.reInitializeData();

				this.app.getRootNav().setRoot(FarmersPage);
			});
	}

	async printPrescription() {
		if (this.addOrderService.pre_projects.length === 0) {
			this.helperService.presentToast(
				"You have not selected place order Or not added products"
			);

			return;
		}

		this.addOrderService.postData.product_data.products = [];
		let noOrderData = false;

		this.addOrderService.pre_projects.forEach(project => {
			if (!project.product && !noOrderData) {
				noOrderData = true;
			}
		});

		if (noOrderData) {
			this.helperService.presentToast("Select product to continue");

			return;
		}

		// chECK FOR ADDRESS FROM db
		const addressValidation = await this.validateCustomerAddress();
		if (!addressValidation) {
			this.helperService.presentToast(
				"State , District , Tehsil or Village are required while placing order, Please click on Save & Continue"
			);

			this.navCtrl.parent.select(1);

			return;
		}

		if (
			this.addOrderService.postData.state == null ||
			this.addOrderService.postData.state == "" ||
			this.addOrderService.postData.district == null ||
			this.addOrderService.postData.district == "" ||
			this.addOrderService.postData.tehsil == null ||
			this.addOrderService.postData.tehsil == "" ||
			this.addOrderService.postData.village == null ||
			this.addOrderService.postData.village == ""
		) {
			this.helperService.presentToast(
				"State , District , Tehsil or Village are required while placing order, Please click on Save & Continue"
			);

			this.navCtrl.parent.select(1);

			return false;
		}

		this.all_added_products = [];

		this.addOrderService.pre_projects.forEach(project => {
			this.addOrderService.postData.product_data.products.push({
				product_id: project.product.product_id,
				product_invoice_name: project.product.product_invoice_name +
					" (" +
					project.product.product_sku +
					" " +
					project.product.product_unit +
					")",
				quantity: project.quantity,
				discount: project.discount
			});
		});

		var checkDuplicates = this.hasDuplicates(this.all_added_products);

		if (checkDuplicates) {
			this.helperService.presentToast(
				"You have added duplicate products, please remove duplicate products"
			);

			return false;
		}

		this.addOrderService.postData.product_data.customer_id = this.addOrderService.postData.customer_id;

		this.apiService
			.post("order/print/prescription", this.addOrderService.postData)
			.subscribe(data => {
				this.isPlaceOrderIsRunning = false;
				this.saveCustomerBtn = false;
				this.generatePrintInvoice(data["data"]);
			});
	}

	addProductAction() {
		let pre_product = {
			id: this.addOrderService.pre_projects.length + 1,
			product_field_app_name: "",
			quantity: 1,
			discount: 0,
			product: null,
			sku: "",
			price: "",
			total: "",
			depo_name: null
		};

		this.addOrderService.pre_projects.push(pre_product);
	}

	removeProduct(index) {
		this.addOrderService.pre_projects.splice(index, 1);
		this.calculateSubTotal();
	}

	selectDepo(index, product) {
		if (!product.product) {
			this.helperService.presentToast("Select product");
			return;
		}

		var ids = [];

		this.addOrderService.pre_projects.forEach(product => {
			if (product.product) {
				ids.push(product.product.product_id);
			}
		});

		var checkDuplicates = this.hasDuplicates(ids);

		if (checkDuplicates) {
			this.helperService.presentToast(
				"You have added duplicate products, please remove duplicate products"
			);
			return false;
		}

		let modalObject: any = {};

		modalObject = this.modalController.create(DepoModalPage, {
			index: index,
			product_id: product.product.product_id,
			type: "addorder"
		});

		modalObject.present();
	}

	getTheArrIndexByKeyForAval(data, id) {
		if (data.length === 0) {
			return null;
		}
		var keepGoing = true;
		var keyVal = null;

		let i = 0;

		for (i = 0; i < data.length; i++) {
			if (keepGoing) {
				if (data[i]["product"]["product_id"] === id) {
					keyVal = i;
					keepGoing = false;
				}
			}
		}

		return keyVal;
	}

	selectedDepo(depo) {
		this.addOrderService.pre_projects[depo.requestIndex].depo_id =
			depo.stock_location_id;

		this.apiService
			.post("products/check/aval/qty", {
				product_id: depo.product_id,
				depo_id: depo.stock_location_id
			})
			.subscribe(result => {
				this.addOrderService.pre_projects[depo.requestIndex].depo_name =
					depo.stock_location_name + ": " + result["data"];
			});
	}

	checkAval(Index, product_id, depo_name, depo_id) {
		this.apiService
			.post("products/check/aval/qty", {
				product_id: product_id,
				depo_id: depo_id
			})
			.subscribe(result => {
				this.addOrderService.pre_projects[Index].depo_name =
					depo_name + ": " + result["data"];
			});
	}

	generatePrintInvoice(contents) {
		var frame1 = document.createElement("iframe");
		frame1.name = "frame3";
		frame1.style.position = "absolute";
		frame1.style.top = "-1000000px";
		document.body.appendChild(frame1);
		var frameDoc = frame1.contentWindow;
		frameDoc.document.open();
		frameDoc.document.write(contents);
		frameDoc.document.close();
		setTimeout(function() {
			window.frames["frame3"].focus();
			window.frames["frame3"].print();
			document.body.removeChild(frame1);
		}, 500);
		return false;
	}
}


// WEBPACK FOOTER //
// ./src/pages/addorder/placeorder/placeorder.ts